module.exports = __webpack_public_path__ + "img/rysBanner.18233f76.png";